import DataTable from 'react-data-table-component'
import tableCustomStyles from './TableCustomeStyle'
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai'
import SortIcon from '../../../assets/svg/SortIcon'
import CustomPagination from '../CustomPagination/CustomPagination'
import './style.css'
import RotatingLinesLoader from '../Loaders/RotatingLinesLoader'

const CollapseableTable = ({
    data,
    columns,
    currentRow,
    setCurrentRow,
    renderTable,
    handleExpandableRowDisabled,
    isSelectableRows = false,
    isLoading,
    // Pagination props (optional)
    removePagination = true,
    pageCount,
    activePage,
    rowPerPages,
    totaldata,
    handleRowsPerPage,
    handlePageClick,
    // Sort props (optional) - only used by tables with sortable columns
    handleColumnSort,
    sortServer = false,
}) => {
    return (
        <>
            <DataTable
                persistTableHead
                customStyles={tableCustomStyles(isSelectableRows)}
                columns={columns}
                data={data}
                expandableRows
                expandableIcon={{
                    collapsed: <AiOutlinePlus size={12} color='mainText' />,
                    expanded: <AiOutlineMinus size={12} color='mainText' />,
                }}
                expandableRowDisabled={handleExpandableRowDisabled}
                expandableRowExpanded={(row) => row === currentRow}
                onRowExpandToggled={(row) => setCurrentRow(row)}
                expandableRowsComponent={renderTable}
                highlightOnHover
                className="table-custom-border"
                progressPending={isLoading}
                progressComponent={<RotatingLinesLoader />}
                sortServer={sortServer}
                onSort={handleColumnSort}
                sortIcon={<SortIcon />}
                pagination={!removePagination}
                paginationServer={!removePagination}
                paginationComponent={!removePagination && handlePageClick ? () => (
                    <CustomPagination
                        handleRowsPerPage={handleRowsPerPage}
                        handlePageClick={handlePageClick}
                        pageCount={pageCount}
                        activePage={activePage}
                        rowPerPages={rowPerPages}
                        totalData={totaldata}
                    />
                ) : undefined}
            />
        </>
    )
}

export default CollapseableTable
